import { render } from "./GameView.vue?vue&type=template&id=c85f8876&scoped=true"
import script from "./GameView.vue?vue&type=script&lang=js"
export * from "./GameView.vue?vue&type=script&lang=js"

import "./GameView.scss?vue&type=style&index=0&id=c85f8876&lang=scss&scoped=true"

import exportComponent from "/Users/lml/Code/threeman-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85f8876"]])

export default __exports__